import React, { Component } from 'react'
import Table from "../../../components/UI/Table/Table";
import { connect } from 'react-redux'
// import { addCompany } from '../actions'
import { sendSelected } from './helper'
// import SME from '../../DO/SME'
// import corporate from '../../DO/Corporate'
import { selectedCorporate, selectedCounterparty, selectedUser, setSearchCounterpartyParameter } from '../Create/actions'
// import StringConst from '../../../StringConst'
import StringConst from '../../../Admin/StringConst';
import './create-table.css';

let that;
const counterpartyTableColumns = [
  {
    Header: "",
    accessor: p => <div><input type="radio" name="counterparty" value={p.id} onChange={that.onCompanyChanged} /></div>,
    id: "company",
    maxWidth: 50,
    className: 'center',
  },
  {
    Header: "Name",
    id: "name",
    accessor: p => <p>{p.counterpartyName}</p>
  },
  {
    Header: "Address",
    accessor: p => <p title={p.address}>{p.address}</p>,
    id: 'address'
  },
  {
    Header: "GST No",
    accessor: "gstNo",
    className: 'center',

  },
  {
    Header: "PAN No",
    accessor: "panNo",
    className: 'center',

  },
  {
    Header: "CIN No",
    accessor: "cinNo",
    className: 'center',

  },
  {
    Header: "Counterparty Status",
    accessor: "counterpartyStatus",
    className: 'center',

  },
  {
    Header: "Contact Number",
    accessor: "contactNumber",
    className: 'center',
  },
  {
    Header: "City",
    accessor: "city",
    className: 'center'
  },
  {
    Header: "State",
    accessor: "state",
    className: 'center'
  },
  {
    Header: "PIN",
    accessor: "pinCode",
    className: 'center'
  },
  {
    Header: "Last Report Updated Date",
    accessor: "lastDataDate",
    className: 'center'
  }

]

const corporateTableColumns = [
  {
    Header: "Select",
    accessor: p => <div><input type="radio" name="corporate" value={p.id} onChange={that.onCompanyChanged} /></div>,
    id: "corporate",
    className: 'center',
    maxWidth: 50,
  },
  {
    Header: "Name",
    accessor: "corporateName",
    className: 'center',
  },
  {
    Header: "Address",
    accessor: p => <p title={p.address}>{p.address}</p>,
    id: 'address'
  },
  {
    Header: "City",
    accessor: "city",
    className: 'center',
  },
  {
    Header: "GST No",
    accessor: "gstNo",
    className: 'center'
  },
  {
    Header: "TAN No",
    accessor: "tanNo",
    className: 'center'
  },
  {
    Header: "PAN No",
    accessor: "panNo",
    className: 'center'
  },
  {
    Header: "Contact Person",
    accessor: "contactPerson"
  },
  {
    Header: "Contact Number",
    accessor: "contactNumber",
    className: 'center'
  },
  {
    Header: "Contact Email",
    accessor: "contactEmail"
  }

]

const userTableColumns = [
  {
    Header: "",
    accessor: p => <div><input type="radio" name="user" value={p.id} onChange={that.onCompanyChanged} /></div>,
    id: "user",

    maxWidth: 50,
  },
  {
    Header: "Name",
    accessor: "username"
  },
  {
    Header: "First Name",
    accessor: "firstname",
  },
  {
    Header: "Last name",
    accessor: "lastname"
  },
  {
    Header: "Email",
    accessor: "email"//contactEmail
  }

]



class TableView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: {},
      corporate: []
    }
    this.tabledata = "";
    that = this;
  }

  /* componentDidUpdate(){
       this.setState({corporate:this.props.corporate});
  } */

  onCompanyChanged = (e) => {
    if (this.props.selected === StringConst.CorporateLabel) {
      let selected = sendSelected(this.props.corporate, e.target.value)
      this.props.selectedCorporate(selected)
    } else if (this.props.selected === StringConst.CounterpartyLabel) {
      let selected = sendSelected(this.props.counterparty, e.target.value)
      this.props.selectedCounterparty(selected)
    } else if (this.props.selected === StringConst.UserLabel) {
      let selected = sendSelected(this.props.users, parseInt(e.target.value, 10))
      this.props.selectedUser(selected)
    }

  }
  onCounterpartyPageChange = (pageIndex) => {
    const { counterpartySearchContext, counterpartyPageNo, counterpartyPageSize, counterpartyHasNext } = this.props;
    if (!counterpartySearchContext) return;

    const newPageNo = pageIndex + 1;
    if (newPageNo > counterpartyPageNo && !counterpartyHasNext) return;
    if (newPageNo < 1) return;

    this.props.fetchCounterpartyPage(
      counterpartySearchContext.parameter,
      counterpartySearchContext.search,
      counterpartySearchContext.countryCode,
      counterpartySearchContext.countryName,
      newPageNo,
      counterpartyPageSize
    );
  }

  onCounterpartyPageSizeChange = (pageSize) => {
    const { counterpartySearchContext } = this.props;
    if (!counterpartySearchContext) return;

    this.props.fetchCounterpartyPage(
      counterpartySearchContext.parameter,
      counterpartySearchContext.search,
      counterpartySearchContext.countryCode,
      counterpartySearchContext.countryName,
      1,
      pageSize
    );
  }

  render() {
    if (this.props.selected === StringConst.CounterpartyLabel) {
      const { counterpartyHasNext, counterpartyLoading, counterpartyPageNo, counterpartyPageSize } = this.props;
      const totalPages = counterpartyHasNext ? counterpartyPageNo + 1 : counterpartyPageNo;
      return (
        <div className="">
          <Table
            data={this.props.counterparty}
            columns={counterpartyTableColumns}
            defaultSorted={[
              {
                id: "City",
                desc: false
              }
            ]}
            defaultPageSize={counterpartyPageSize || 10}
            pageSize={counterpartyPageSize || 10}
            className="CreateCaseModalTable highlight"
            manual={true}
            page={counterpartyPageNo - 1}
            pages={totalPages}
            onPageChange={this.onCounterpartyPageChange}
            onPageSizeChange={this.onCounterpartyPageSizeChange}
            loading={counterpartyLoading}
          />
        </div>
      )
    }
    else if (this.props.selected === StringConst.CorporateLabel) {
      return (
        <div className="">
          <Table
            data={this.props.corporate}
            columns={corporateTableColumns}
            defaultSorted={[
              {
                id: "City",
                desc: false
              }
            ]}
            defaultPageSize={10}
            className="CreateCaseModalTable highlight"
          />
        </div>
      )
    }

    else {
      return (
        <div className="">
          <Table
            data={this.props.users}
            columns={userTableColumns}
            defaultPageSize={10}
            className="-highlight"
          />
        </div>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  modal: state.createCase.modal,
  companyData: state.createCase.searchParam,
  GSTNO: state.createCase.GSTNo,
  corporate: state.createCase.corporate,
  counterparty: state.createCase.counterparty,
  counterpartyPageNo: state.createCase.counterpartyPageNo,
  counterpartyPageSize: state.createCase.counterpartyPageSize,
  counterpartyHasNext: state.createCase.counterpartyHasNext,
  counterpartyLoading: state.createCase.counterpartyLoading,
  counterpartySearchContext: state.createCase.counterpartySearchContext,
  users: state.createCase.users
});

const mapDispatchToProps = (dispatch) => {
  return {
    // toggleModalCreate: () => { dispatch(toggleModalCreate()); },//addGst
    // addCompany: (companyNo) => { dispatch(addCompany(companyNo)); },//selectedCorporate
    selectedCorporate: (corp) => { dispatch(selectedCorporate(corp)); },//
    selectedCounterparty: (corp) => { dispatch(selectedCounterparty(corp)); },//selectedUser
    selectedUser: (corp) => { dispatch(selectedUser(corp)); },
    fetchCounterpartyPage: (param, search, countryCode, countryName, pageNo, pageSize) => {
      dispatch(setSearchCounterpartyParameter(param, search, countryCode, countryName, pageNo, pageSize));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableView);
//export default TableView
